const units = [
  {value: 'each', display: 'Each', unitOfMeasureClass: 'each'},
  {value: 'g', display: 'Grams (g)', unitOfMeasureClass: 'weight'},
  {value: 'mg', display: 'Milligrams (mg)', unitOfMeasureClass: 'weight'},
  {value: 'oz', display: 'Ounces (oz)', unitOfMeasureClass: 'weight'},
  {value: 'mL', display: 'Millilitres (mL)', unitOfMeasureClass: 'volume'},
  {value: 'fl oz', display: 'Fluid Ounces (fl oz)', unitOfMeasureClass: 'volume'},
];

export default units;

export const GramsPerWeightUnit = Object.freeze({
  'lb': 453.59237,
  'kg': 1000,
  'g': 1,
  'mg': 0.001,
  'oz': 28.349523
});

export const MilliLitresPerVolumeUnit = Object.freeze({
  'mL': 1,
  'L': 1000,
  'fl oz': 29.5735295625, // USA
  'gal': 3785.4118,
});



// WEBPACK FOOTER //
// ./src/Product/units.js